import { BellRing } from "lucide-react";
import { usePush } from "@/hooks/usePush";

const MSG = {
  denied: "الإشعارات محظورة. فعّلها من إعدادات المتصفح ليصلك تنبيه بالمهام الجديدة.",
  "ios-install": "على الآيفون: اضغط زر المشاركة ثم «إضافة إلى الشاشة الرئيسية» وافتح التطبيق منها لتفعيل الإشعارات.",
  error: "تعذّر تفعيل الإشعارات على هذا الجهاز. ستظهر التنبيهات داخل التطبيق فقط.",
};

export const PushPrompt = () => {
  const { state, enable } = usePush();
  if (state === "unsupported") return null;
  if (state === "on") return <p className="max-w-2xl mx-auto px-4 mt-2 text-xs text-emerald-400" data-testid="push-on">● إشعارات الجوال مفعّلة للمهام الجديدة</p>;
  return (
    <div className="max-w-2xl mx-auto px-4 mt-3" data-testid="push-prompt">
      <div className="rounded-lg border border-brand-sky/50 bg-panel p-3 text-sm flex items-center gap-3">
        <BellRing size={20} className="text-brand-sky shrink-0" />
        <p className="me-auto text-slate-200">{MSG[state] || "فعّل الإشعارات ليصلك تنبيه على الجوال عند إسناد مهمة جديدة حتى لو كان التطبيق مقفولاً."}</p>
        {state === "default" && (
          <button onClick={enable} data-testid="push-enable-button" className="h-10 px-4 shrink-0 rounded-lg bg-brand-red text-white font-bold hover:bg-brand-red-dark transition-colors">تفعيل</button>
        )}
      </div>
    </div>
  );
};
